import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import FaderImage from '../../assets/headquarters/fader.webp'
import WastImage from '../../assets/headquarters/wast.webp'
import CommunityImage from '../../assets/community/community.webp'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { postIndexForm } from '../../api/community'
import HomeBanner from '../../components/HomeBanner'
import SolutionCards from '../../containers/SolutionCards'
import CommunityCards from '../../containers/CommunityCards'
import AboutUsImages from '../../components/AboutUsImages'
import Vidita from '../../assets/brand/Vidita'
import AccountIcon from '../../assets/icons/AccountIcon'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import MailIcon from '../../assets/icons/MailIcon'
import PhoneIcon from '../../assets/icons/PhoneIcon'
import WorkIcon from '../../assets/icons/WorkIcon'
import VideoBanner from '../../components/VideoBanner'
import SendFormModal from '../../components/modals/SendFormModal'
import WorkWithUs from '../../containers/WorkWithUs'
import InputAnimated from '../../components/InputAnimated'
import ContactForm from '../../components/ContactForm'


const INTEREST_TYPES = [
  'Espacios compartidos',
  'Salas de reuniones',
  'Oficinas privadas',
  'Eventos sociales',
  'Jornadas laborales',
  'Alianzas estratégicas',
]

const INTEREST_DICTIONARY = {
  'Espacios compartidos': 'Espacio compartido',
  'Salas de reuniones': 'Salas de reuniones',
  'Oficinas privadas': 'Oficinas privadas',
  'Eventos sociales': 'Eventos sociales',
  'Jornadas laborales': 'Jornadas laborales',
  'Alianzas estratégicas': 'Alianzas estratégicas'
}


const Home = () => {
  const [showModal, setShowModal] = useState(false)

  const toggleShowmodal = () => {
    setShowModal((prev) => !prev)
  }

  const closeShowmodal = () => {
    setShowModal(false)
  }


  const formik = useFormik({
    initialValues: {
      name: '',
      last_name: '',
      company_name: '',
      email: '',
      phone: '',
      interest: 'Oficinas privadas',
      message: ''
    },
    validateOnChange: false,
    validationSchema: Yup.object({
      name: Yup.string()
        .required('Tu nombre es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      last_name: Yup.string()
        .required('Tu apellido es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      company_name: Yup.string().max(50, 'Máximo de caracteres: 50'),
      email: Yup.string()
        .email('Email no valido')
        .required('Tu email es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      phone: Yup.number().required('El número de teléfono es requerido').typeError('El número de teléfono es inválido'),
      interest: Yup.string()
        .required('Selecciona un tipo de consulta'),
      message: Yup.string().required('El mensaje es requerido')
    }),
    onSubmit: async (data) => {
      if (data.email.includes(' ')) {
        data.email = data.email.replace(/ /g, '')
      }

      const dataWithInterest = {
        ...data,
        interest: INTEREST_DICTIONARY[data.interest]
      }

      const formFiltered = Object.entries(dataWithInterest).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      )
      console.log(dataWithInterest)
      console.log(formFiltered)

      const response = await postIndexForm(formFiltered)
      if (response) {
        toggleShowmodal()

        window.dataLayer.push({
          'event': 'submit_form'
        })
      }
      formik.resetForm()
    },
  })

  return (
    <>
      <main className="Home">
        <HomeBanner/>

        {/* Solutions */}
        <section className="Home-Solutions">
          <div className="Home-Solutions__Tramas"></div>

          <div className="Home-Solutions__Content container-custom">
            <h2 className="title z-1">
              Soluciones Vida Cowork
            </h2>
            <span className="text-1 fw-semibold z-1">
              Encontrá la mejor opción para tu proyecto
            </span>
          </div>

          <SolutionCards/>
          {/* <PlanCards /> */}
        </section>

        {/* HeadQuarters */}
        <section className="Home-HeadQuarters container-custom">
          <div className="Home-HeadQuarters__Item">
            <div className="Home-HeadQuarters__Item-Content">
              <h3 className='title-2'>SEDE FADER</h3>
              <p className='text-3'>
                Amplia, confortable y rodeada de naturaleza, esta sede se distingue por su atmósfera relajada y su patio con galerías que invitan a conectar desde otro lugar. Un espacio versátil, pensado para equipos que valoran el equilibrio entre productividad, bienestar y un entorno inspirador.
              </p>
              <Link
                to='/sedes?fader=true'
                className='button-new-orange d-flex gap-2'
              >
                Ver más
                <ArrowRightIcon width={20} height={20}/>
              </Link>
            </div>

            <div className="Home-HeadQuarters__Item-Image-Container">
              <img
                className="Home-HeadQuarters__Item-Image"
                src={FaderImage}
                alt='Sede Fader'
                title='Sede Fader'
              />
            </div>
          </div>
          <div className="Home-HeadQuarters__Item">
            <div className="Home-HeadQuarters__Item-Image-Container">
              <img
                className="Home-HeadQuarters__Item-Image"
                src={WastImage}
                alt='Sede Hugo Wast'
                title='Sede Hugo Wast'
              />
            </div>
            <div className="Home-HeadQuarters__Item-Content">
              <h3 className='title-2'>SEDE HUGO WAST</h3>
              <p className='text-3'>
                Situada en el corazón del Cerro de las Rosas, nuestra sede se destaca por su vista panorámica a las sierras y un entorno natural que transforma la jornada laboral. Con materiales de alta calidad y terminaciones premium, ofrece un equilibrio ideal entre elegancia, funcionalidad y bienestar para equipos y empresas que buscan potenciar su productividad en un espacio único.
              </p>
              <Link
                to='/sedes?wast=true'
                className='button-new-orange d-flex gap-2'
              >
                Ver más
                <ArrowRightIcon width={20} height={20}/>
              </Link>
            </div>
          </div>
        </section>

        {/* Community */}
        <section className="Home-Community--One container-fluid">
          <div className="Home-Community__Content">
            <div className="Home-Community__Title-Container">
              <h2 className="title-2">
                Una gran comunidad de proyectos y personas
              </h2>
              <span className="text-3">
                Cada reseña es un reflejo de las conexiones, el crecimiento y la inspiración que se
                vive en nuestro espacio. Descubrí lo que dicen quienes ya forman parte de la
                comunidad
              </span>
            </div>

            <CommunityCards/>
          </div>

          <div className="Home-Community__Tramas"></div>
        </section>

        <section className="Home-Community--Two container-fluid">
          <div className="Home-Community__Content container-custom">
            <h2 className="caption">
              Nuestra comunidad
            </h2>

            <div className="Home-Community__Image-Container">
              <img
                className='Home-Community__Image'
                src={CommunityImage}
                alt="Nuestra comunidad"
                title="Nuestra comunidad"
              />

              <div className="Home-Community__Image-Text">
                <span className="text-2">
                  Nuestra comunidad reúne a profesionales, emprendedores y empresas
                  que comparten una visión: crecer juntos a través de la colaboración,
                  la innovación y el impacto positivo. Fomentamos conexiones estratégicas
                  que generan oportunidades, beneficios exclusivos y experiencias
                  enriquecedoras, ayudando a las marcas a conectar con un público
                  que comparte sus valores.
                </span>

                <div className="Home-Community__Divisor"></div>

                <Link
                  to='/comunidad'
                  className='button-new-orange d-flex gap-2'
                >
                  Leer más
                  <ArrowRightIcon width={20} height={20}/>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* About Us */}
        <section className="Home-AboutUs container-custom">
          <h2 className="title">
            Sobre nosotros
          </h2>

          <div className="container-custom">
            <div className="row text-gray-dark gap-3 gap-md-0">
              <span className="text-3 col-12 col-md-6 p-0 px-md-4">
                En Vida, cada elección es un paso hacia tu evolución. No es perder quién sos, sino descubrir la mejor versión de vos.
              </span>
              <span className="text-3 col-12 col-md-6 p-0 px-md-4">
                Conectá con la naturaleza, respetá los procesos y abrazá tu transformación. Más que un cowork, somos un espacio para crecer, crear y reinventarte. Vidalizate.
              </span>
            </div>
          </div>

          <AboutUsImages/>

          <VideoBanner/>
        </section>

        {/* Form */}
        <form className="ContactForm container-custom" onSubmit={formik.handleSubmit}>
          <h2 className="title text-green">
            Conseguí tu oficina
          </h2>
          <span className="text-3 text-green">
            Formá parte de nuestra comunidad y descubrí el espacio ideal para trabajar, crecer y conectar.
          </span>

          <div className="ContactForm__Inputs">
            <InputAnimated
              label="Nombre*"
              name="name"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.errors.name}
              icon={<AccountIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Apellido*"
              name="last_name"
              type="text"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              error={formik.errors.last_name}
              icon={<AccountIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Email/correo electrónico*"
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.errors.email}
              icon={<MailIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Número telefónico*"
              name="phone"
              type="tel"
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={formik.errors.phone}
              icon={<PhoneIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Nombre de tu empresa o marca"
              name="company_name"
              type="text"
              value={formik.values.company_name}
              onChange={formik.handleChange}
              error={formik.errors.company_name}
              icon={<WorkIcon width={24} height={24} className='text-green'/>}
            />
          </div>

          <div className="ContactForm__Inputs2">
            <div className='d-flex flex-column gap-2 w-full align-items-start'>
              <label className='text-black text-4'>Quiero saber sobre:</label>
              <InputAnimated
                withoutLabel
                className='custom-select'
                name="interest"
                label='Quiero saber sobre:'
                placeholder='Selecciona un tema'
                angleColor='#1E1E1E'
                type="select"
                value={formik.values.interest}
                list={INTEREST_TYPES}
                onChange={formik.setFieldValue}
                error={formik.errors.interest}
                icon={<WorkIcon width={24} height={24} className='text-green'/>}
              />
            </div>

            <div className='d-flex flex-column w-100 position-relative'>
              <textarea
                className="ContactForm__Textarea"
                name="message"
                id="message"
                cols="30"
                rows="5"
                placeholder="Escribe aquí tu consulta"
                value={formik.values.message}
                onChange={(e) => formik.setFieldValue('message', e.target.value)}
              />
              {formik.errors.message && (
                <span className="Input__Error">
                  {formik.errors.message}
                </span>
              )}
            </div>
          </div>

          <button
            className="ContactForm__Button button-new-orange"
            type="submit"
            onClick={formik.handleSubmit}
          >
            Enviar
          </button>
        </form>

        <WorkWithUs/>

        {showModal && (
          <SendFormModal
            closeModal={closeShowmodal}
            sended
          />
        )}
      </main>
    </>
  )
}

export default Home
